import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useContext, useState } from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, propTypes as reduxFormPropTypes, reduxForm, SubmissionError } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ModalCloseBtn, ModalSaveBtn } from '../statelessComponents/Buttons/ButtonsInModals';
import s from './AddVismaSignModal.scss';
import messages from './messages';
import TextField from '../statelessComponents/FormFields/TextField';
import ContextProvider from '../../context';
import addVismaSignValidation from './addVismaSignValidation';
import ConfirmDeleteDialog from '../statelessComponents/ConfirmDeleteDialog';
import MultipleSignersFormField from './MultipleSignersFormField/MultipleSignersFormField';
import intlPropTypes from '../../constants/intlPropTypes';
var AddVismaSignModal = function AddVismaSignModal(_ref) {
  var formatMessage = _ref.intl.formatMessage,
    form = _ref.form,
    handleSubmit = _ref.handleSubmit,
    submitting = _ref.submitting,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    submitRoute = _ref.submitRoute,
    invalid = _ref.invalid,
    touch = _ref.touch,
    isMultipleSigners = _ref.isMultipleSigners,
    maxSignersAmount = _ref.maxSignersAmount,
    _ref$customMessages = _ref.customMessages,
    _ref$customMessages2 = _ref$customMessages === void 0 ? {} : _ref$customMessages,
    modalSaveBtnText = _ref$customMessages2.modalSaveBtnText,
    addVismaSignBtnLabel = _ref$customMessages2.addVismaSignBtnLabel,
    confirmTitle = _ref$customMessages2.confirmTitle,
    getInvitationsToSignWillBeSentTo = _ref$customMessages2.getInvitationsToSignWillBeSentTo,
    defaultSigners = _ref.defaultSigners;
  var _useContext = useContext(ContextProvider),
    fetch = _useContext.fetch;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitted = _useState2[0],
    setIsSubmitted = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isConfirmSaveOpen = _useState4[0],
    setIsConfirmSaveOpen = _useState4[1];
  var hideConfirmSave = useCallback(function () {
    setIsConfirmSaveOpen(false);
  }, [isConfirmSaveOpen, setIsConfirmSaveOpen]);
  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsSubmitted(false);
            return _context2.abrupt("return", fetch(submitRoute, {
              method: 'POST',
              body: JSON.stringify(data)
            })["catch"](function (err) {
              throw new SubmissionError({
                _error: err && err.message
              });
            }).then( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                var resJson;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (res.ok) {
                        _context.next = 7;
                        break;
                      }
                      _context.next = 3;
                      return res.json();
                    case 3:
                      resJson = _context.sent;
                      if (!resJson.message) {
                        _context.next = 6;
                        break;
                      }
                      throw new SubmissionError({
                        _error: resJson.message
                      });
                    case 6:
                      throw new SubmissionError(resJson);
                    case 7:
                      setIsSubmitted(true);
                      onSubmit();
                      onClose();
                    case 10:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }()));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleConfirmationAccepted = function handleConfirmationAccepted(event) {
    event.preventDefault();
    hideConfirmSave();
    return handleSubmit(submit)(event);
  };
  var showConfirmSave = function showConfirmSave(event) {
    event.preventDefault();
    var values = form.values,
      syncErrors = form.syncErrors;
    if (invalid) {
      return touch.apply(void 0, _toConsumableArray(Object.keys(syncErrors || values)));
    }
    return setIsConfirmSaveOpen(true);
  };
  return /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Typography, {
    variant: "h5",
    component: "h1",
    id: "add-visma-sign-modal-title"
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.modalTitle)), /*#__PURE__*/_jsx("form", {
    noValidate: true,
    autoComplete: "off"
  }, void 0, !isMultipleSigners && /*#__PURE__*/_jsx(Field, {
    name: "signerEmail",
    type: "email",
    label: formatMessage(messages.signerEmail),
    margin: "normal",
    component: TextField,
    fullWidth: true,
    disabled: submitting,
    className: s.signerEmail
  }), isMultipleSigners && /*#__PURE__*/_jsx(FieldArray, {
    name: "signerEmails",
    component: MultipleSignersFormField,
    label: formatMessage(messages.signerEmail),
    fullWidth: true,
    disabled: submitting,
    maxSignersAmount: maxSignersAmount,
    defaultSigners: defaultSigners
  }), /*#__PURE__*/_jsx(ModalSaveBtn, {
    "data-test-id": "Cr8aoWHo4ntr-VUDAivML",
    isLoaderOn: submitting,
    onClick: showConfirmSave,
    isSuccessed: isSubmitted,
    mobileLandscapeRelative: true,
    disabled: submitting,
    tooltip: addVismaSignBtnLabel || formatMessage(messages.addVismaSign),
    id: "add-visma-sign-modal-generate-bundle-btn"
  })), /*#__PURE__*/_jsx(ModalCloseBtn, {
    "data-test-id": "nj1rejk78cw4qPmMe1b3r",
    fitMobileLandscapeFullWidth: true,
    id: "add-visma-sign-modal-close-btn",
    onClick: onClose
  }), /*#__PURE__*/_jsx(ConfirmDeleteDialog, {
    isShown: isConfirmSaveOpen,
    onClose: hideConfirmSave,
    submit: handleConfirmationAccepted,
    isDeleting: submitting,
    deleteBtnId: "confirm-add-visma-sign",
    submitColor: "primary",
    deleteBtnLabel: modalSaveBtnText || formatMessage(messages.saveLabel),
    title: confirmTitle || /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmTitle),
    description: !getInvitationsToSignWillBeSentTo ? /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.invitatationToSignWillBeSentTo, {
      values: {
        signerEmail: _.get(form, 'values.signerEmail', '')
      }
    })) : getInvitationsToSignWillBeSentTo(_.get(form, 'values.signerEmails', '').join(', '))
  }));
};
export default compose(injectIntl, withStyles(s), connect(function (state, props) {
  var _props$defaultSigners;
  var initialValues = {};
  if (props.isMultipleSigners) {
    initialValues.signerEmails = [''];
  }
  if (((_props$defaultSigners = props.defaultSigners) === null || _props$defaultSigners === void 0 ? void 0 : _props$defaultSigners.length) > 0) {
    initialValues.signerEmails = _toConsumableArray(props.defaultSigners);
  }
  return {
    initialValues: initialValues
  };
}), reduxForm({
  form: 'addVismaSign',
  validate: addVismaSignValidation
}), connect(function (state) {
  return {
    form: state.form.addVismaSign
  };
}))(AddVismaSignModal);